export default __webpack_public_path__ + "static/media/discord.b5cd7971.png";